<template>
  <pt-active-setting class="pt-active-setting__withData" :banner-list="bannerList" v-loading="loading" @submit="submit" ref="form"
  :save-loading="saveLoading"></pt-active-setting>
</template>

<script>
import PtActiveSetting from './index'
export default {
  name: 'pt-active-setting__withData',
  components: {
    'pt-active-setting': PtActiveSetting
  },
  data () {
    return {
      bannerList: [],
      loading: false,
      saveLoading: false
    }
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    submit (from) {
      this.saveLoading = true
      this.$store.dispatch('bannersReplace', from).then(res => {
        this.saveLoading = false
        this.$message.success('编辑活动成功')
      }).catch(err => {
        this.saveLoading = false
        this.$message.error(err || '编辑活动失败')
      })
    },
    getBnnerDetail () {
      let data = {
        example: {
          type: 'POPUP'
        },
        pageable: {
          page: 0,
          size: 9999
        }
      }
      this.loading = true
      this.$store.dispatch('getActiveSetList', data).then(res => {
        this.loading = false
        this.bannerList = res
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取广告位列表失败')
      })
    }
  },
  created () {
    this.getBnnerDetail()
  }
}
</script>
